import { ArchiveDealConfirmationModal } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageDeal/DealArchiveButton/ArchiveDealConfirmationModal/ArchiveDealConfirmationModal';
import { useDealArchiveButton } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageDeal/DealArchiveButton/useDealArchiveButton';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { memo } from 'react';

interface Props {
	isDealArchived: boolean;
	dealId: string;
	refetchDealData: () => void;
}

const DealArchiveButton = ({ isDealArchived, dealId, refetchDealData }: Props) => {
	const { showArchiveDealConfirmationModal, setShowArchiveDealConfirmationModal, onSubmit } =
		useDealArchiveButton(dealId, isDealArchived, refetchDealData);

	const archiveButton = isDealArchived ? (
		<Button variant="delete" onClick={() => setShowArchiveDealConfirmationModal(true)}>
			Unarchive Deal
		</Button>
	) : (
		<Button variant="delete" onClick={() => setShowArchiveDealConfirmationModal(true)}>
			Archive Deal
		</Button>
	);

	return (
		<div>
			{archiveButton}
			{showArchiveDealConfirmationModal && (
				<ArchiveDealConfirmationModal
					onSubmit={onSubmit}
					onClose={() => setShowArchiveDealConfirmationModal(false)}
					isDealArchived={isDealArchived}
				/>
			)}
		</div>
	);
};
const _DealArchiveButtonExport = memo(DealArchiveButton);

export { _DealArchiveButtonExport as DealArchiveButton };
